import {
  isRejectedWithValue,
  type Middleware,
  type UnknownAction,
} from '@reduxjs/toolkit';
import { bbkApiSlice } from '@bbkAdminRedux/rtkq/bbkApi.slice';
import { brightbackAuthSlice } from '@bbkAdminRedux/rtkq/brightback-auth.slice';
import { internalBbkApiSlice } from '@bbkAdminRedux/rtkq/internal.bbkApi.slice';
import BrightbackSession from '@bbkAdminUtils/brightback-session';

let isUnauthorizedRedirectInProgress = false;

const getRejectedStatus = (action: UnknownAction) => {
  const payload =
    'payload' in action && typeof action.payload === 'object'
      ? action.payload
      : undefined;

  if (!payload) return undefined;

  if ('originalStatus' in payload && typeof payload.originalStatus === 'number')
    return payload.originalStatus;

  if ('status' in payload && typeof payload.status === 'number') {
    return payload.status;
  }

  return undefined;
};

const isAuthenticatedApiAction = (action: UnknownAction) =>
  typeof action.type === 'string' &&
  (action.type.startsWith(`${bbkApiSlice.reducerPath}/`) ||
    action.type.startsWith(`${internalBbkApiSlice.reducerPath}/`));

const getRedirectUrl = () =>
  window.location.pathname + window.location.search + window.location.hash;

export const unauthorizedRedirectMiddleware: Middleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    const result = next(action);

    if (isUnauthorizedRedirectInProgress) return result;
    if (!isRejectedWithValue(action)) return result;
    if (!isAuthenticatedApiAction(action)) return result;
    if (!BrightbackSession.getAccessToken()) return result;
    if (getRejectedStatus(action) !== 401) return result;

    isUnauthorizedRedirectInProgress = true;
    BrightbackSession.setAuthAlert('Please log in again for security');
    dispatch(
      brightbackAuthSlice.endpoints.signOut.initiate({
        redirect: getRedirectUrl(),
      }) as unknown as UnknownAction
    );

    return result;
  };
